exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.margin-top[data-v-a6423d86]{margin-top:1rem\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/bancoDados/components/InformacoesCadastrante.vue"],"names":[],"mappings":";AAuCA,6BACE,eAAgB;CACjB","file":"InformacoesCadastrante.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.margin-top {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a6423d86","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/bancoDados/components/InformacoesCadastrante.vue
// module id = KoG1
// module chunks = 11